import React, { useEffect, useState } from 'react'
import './Navbar.css'
import imgg from '../../../assets/brand/favicon.png'
import { AbstructVar } from '../../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../general/general-component/abstruct-component/AbstructLang';
import useClickOutside from '../../../useClickOutside';
import { useSelectorCustom } from '../../general/general-component/abstruct-component/useSelectorCustom';
import { loadNotifications } from '../../../store/Actions/ActionNotifications';
import NotifyInnerLoader from '../../general/inner-loader/NotifyInnerLoader'
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';

function Notify({ setNotify, langLocal }) {

    let { dispatch, navigate } = AbstructVar()


    const [offset, setOffset] = useState(0); // Offset for pagination
    const [limit, setLimit] = useState(3); // Number of records to load per request
    const [hasMore, setHasMore] = useState(true);

    let { translate } = AbstructLang()

    const { notifications, loadingNotifications } = useSelectorCustom();

    let domNode = useClickOutside(() => {
        setNotify(false);
    });

    const fetchMoreData = () => {
        setLimit(limit + 3); // Increase the limit for the next fetch
        dispatch(loadNotifications(offset, limit, setHasMore));
    };

    const refreshFunction = () => {
        setLimit(limit + 3); // Increase the limit for the next fetch
        // dispatch(loadNotifications(0, limit, setHasMore));
    };

    useEffect(() => {
        // Fetch initial data
        dispatch(loadNotifications(offset, limit, setHasMore));
    }, [limit]);


    return (
        <div className={langLocal == 'ar' ? 'notify notifyL' : 'notify notifyR'} ref={domNode} id="scrollableDiv">

            <h5 className={langLocal === 'ar' ? 'textRight' : 'textLeft'}>{translate('Notification')}<span className='notify-count'>({notifications.length})</span></h5>



            <div id="scrollableDiv" className='notify-scroll-container'>

                {notifications.map((items, index) => (
                    <div className='row_notify' key={index}>
                        <p className={`date_notification ${langLocal === 'ar' ? "date_notification_ar" : "date_notification_en"} `} >{moment(items.notification.created_at).format("YYYY-MM-DD")}  /  {moment(items.notification.created_at).format("HH:mm A")}</p>
                        <img className='margin_left_25' src={imgg} alt='Notification Image' />
                        <div className='row_notify_info'>
                            <span className={`title_notify textRight`} dangerouslySetInnerHTML={{ __html: items.notification.title }} />
                            <span className={`date_notify textRight`} dangerouslySetInnerHTML={{ __html: items.notification.body }} />
                        </div>
                    </div>
                ))}

            </div>

            <div className='div_more'>

                <span onClick={refreshFunction}>{translate('view_more')}</span>

            </div>

        </div>
    )
}

export default Notify